export default "__VITE_ASSET__iDOVktLS__"